<template>
  <div id="app"
       class="app-wrap"
       :class="{
      'first-bg': indexFlag == 0,
      'two-bg': indexFlag == 1,
      'three-bg': indexFlag == 2,
      'four-bg': indexFlag == 3
    }">
    <div id="preloadedImages"></div>
    <div class="header"
         ref="main"
         v-if="active != '/adminVideo'"
         :class="{ 'opa-bg': active == '/index' }">
      <img class="logo"
           :src="bLogo"
           @click="goIndex"
           alt />
      <div class="menu-block"
           :class="{ loginOutLeft: !this.userId }">
        <div class="mebu-item"
             v-for="(item, index) in menuList"
             :key="index"
             @click="changeTab(item.keyword, index)">
          <div>{{ item.name }}</div>
          <div>{{ item.ename }}</div>
          <img v-if="active == '/' + item.keyword"
               src="./assets/img/navLine.png"
               alt />
        </div>
        <div v-if="showPage">
          <el-menu :default-active="activeIndex"
                   class="el-menu-demo user-right"
                   mode="horizontal"
                   @select="handleSelect">
            <el-submenu :index="activeIndex"
                        popper-class="loginout-box">
              <template slot="title">
                <i class="el-icon-user-solid"></i><span class="loginout-name">{{ username }}</span>
              </template>
              <el-menu-item index="1" v-if="roleType != 3">我的订单</el-menu-item>
              <el-menu-item index="4" v-if="roleType == 3">去接单</el-menu-item>
              <el-menu-item index="5" v-if="roleType == 3">我的接单</el-menu-item>
              <el-menu-item index="2">修改密码</el-menu-item>
              <el-menu-item index="3">退出</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
        <!-- <div v-else>
          <span class="nav-login" @click="showLogin">登录</span>
        </div> -->
      </div>
    </div>
    <router-view />
    <div class="basic-footer"
         v-if="active != '/logistics' && active != '/adminVideo'">
      <div class="footer-top">
        <div class="footer-left">
          <img src="./assets/img/footer-slogon.png"
               alt />
          <div class="item mt30">
            <img src="./assets/img/footer-email.png"
                 alt />
            <span>{{ info && info.email }}</span>
          </div>
          <div class="item">
            <img src="./assets/img/footer-phone.png"
                 alt />
            <span>{{ info && info.tel }}</span>
          </div>
          <div class="item">
            <img src="./assets/img/footer-address.png"
                 alt />
            <span>{{ info && info.addr }}</span>
          </div>
          <!-- <div class="item" style="cursor:pointer;display:inline-block" @click="goManage">
            <img src="./assets/img/lj.png"
                 alt />
            <span style="color:#1b63d5">Log On</span>
          </div> -->
        </div>
        <div class="footer-right">
          <img src="./assets/img/qrcode.png"
               alt />
          <img src="./assets/img/applet.png"
               alt />
        </div>
      </div>
      <div class="footer-bottom">
        <img src="./assets/img/logo-bottom.png"
             alt />
        <div class="text">
          <p class="bottomT">
            <span>{{ info && info.copyright }}</span>
            <a href="https://beian.miit.gov.cn/#/Integrated/index"
               target="_blank">{{ info && info.recode_number }}</a>
          </p>
          <p class="bottomP">
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?spm=875.7931836/B.a2226n1.72.66144265c2MeQt&recordcode=42010302002409"
               target="_blank">鄂公网安备{{ info && info.gwab }}号</a>
            <a href="https://beian.miit.gov.cn/#/Integrated/index"
               target="_blank"
               class="ml40">增值电信业务经营许可证：{{ info && info.zzywxhz }}</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from "@/utils/eventBus";
import SystemService from "@/services/systemService";
export default {
  name: "app",
  data () {
    return {
      loginTab: '',
      userId: "",
      username: "",
      roleType: '',
      showPage: false,
      activeIndex: "1",
      menuList: [
        {
          name: "首页",
          ename: "Home",
          keyword: "index"
        },
        {
          name: "关于我们",
          ename: "About",
          keyword: "about"
        },
        {
          name: "核心业务",
          ename: "Bussiness",
          keyword: "bussiness"
        },
        {
          name: "新闻动态",
          ename: "News",
          keyword: "news"
        },
        {
          name: "企业文化",
          ename: "Culture",
          keyword: "culture"
        },
        {
          name: "加入我们",
          ename: "Join",
          keyword: "join"
        },
        {
          name: "数据中心",
          ename: "DataCenter",
          keyword: "dataCenter"
        },
        {
          name: "数智云",
          ename: "Logistics",
          keyword: "logistics"
        },
        {
          name: "车船预定",
          ename: "Reserve",
          keyword: "reserve"
        }
      ],
      info: null,
      active: "/index",
      indexFlag: 0,
      wLogo: require("./assets/img/logo-w.png"),
      bLogo: require("./assets/img/logo-b.png")
    };
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        let self = this;
        this.active = val.path;
        if (val.path == "/" || val.path == "/index") {
          this.indexFlag = 0;
        } else {
          this.indexFlag = 5;
          if (val.path === "/detail") {
            this.active = "/bussiness";
          } else if (val.path === "/article") {
            this.active = "/news";
          } else if (val.path === "/content") {
            this.active = "/culture";
          }
        }
        this.userId = this.$cookies.get("ysUserId");
        this.username = this.$cookies.get("username");
        this.roleType = this.$cookies.get("ysRoleType");
        let params = {
          url: ""
        };
        if (val.query.id) {
          params.url = val.path + "?id=" + val.query.id;
        } else {
          params.url = val.path;
        }
        SystemService.postTracking(params).then(data => { });
      },
      deep: true
    }
  },
  mounted () {
    this.isLogin();
    window.addEventListener("beforeunload", this.fn);
    this.changeBg();
    this.getInfo();
  },
  methods: {
    handleSelect (key, keyPath) {
      this.activeIndex = key;
      if (key == 3) {
        this.userId = false;
        this.$cookies.set("ysUserId", "", -1);
        SystemService.loginOut().then(res => {
          //忘记密码页面点击退出时
          this.loginTab = this.$route.query.tab;
          if (this.loginTab) {
            if (this.active == "/reserve") {
              this.$router.replace({ path: "/reserve" });
            } else {
              //和我的订单
              this.$router.replace({ path: "/logistics" });
            }
            if (this.active != '/myOrder') {
              //解决页面跳转后不刷新的问题
              setTimeout(() => {
                window.location.reload()
              }, 20);
            }
          } else {
            window.location.reload()
          }
        })

      } else if (key == 1) {
        this.$router.push({ path: '/myOrder?tab=1' });
      } else if (key == 4) {
        this.$router.push({ path: '/carOrder' });
      } else if (key == 5) {
        this.$router.push({ path: '/driverOrder' });
      } else {
        if (this.active == "/reserve") {
          this.$router.replace({ path: "/reserve?tab=2" });
        } else {
          this.$router.replace({ path: "/logistics?tab=2" });
        }
      }
    },
    goManage() {
      window.open(this.info.admin_url, false)
    },
    isLogin () {
      SystemService.getUserInfo().then(res => {
        if (res && res.id) {
          this.userId = res.id
          this.username = res.username
          this.roleType = res.role_type
          if (res.role_type != 3) {
            this.$cookies.set('ysUserId', res.id)
            this.$cookies.set('ysRoleType', res.role_type)
            this.$cookies.set('username', res.username)
            this.showPage = true;
          } else {
            this.showPage = false;
            this.userId = '';
            this.$cookies.set("ysUserId", "", -1);
          }
        } else {
          this.showPage = false;
          this.userId = '';
          this.$cookies.set("ysUserId", "", -1);
        }
      })
    },
    changeTab (path, index) {
      if (index == 6) {
        window.open("https://www.wuhanyouhao.net", "_blank");
      } else {
        this.active = "/" + path;
        this.$router.push({ path: '/' + path });
      }
    },
    goIndex () {
      this.$router.push({ path: "/index" });
    },
    getInfo () {
      SystemService.infoDetail().then(data => {
        this.info = data;
      });
    },
    fn () {
      window.scrollTo(0, 0);
    },
    changeBg () {
      let _this = this;
      eventBus.$on("getFlag", function (index) {
        _this.indexFlag = index;
      });
    },
    showLogin () {
      if (this.$route.path == '/reserve') {
        this.$router.replace({ path: "/reserve" });

      } else {
        this.$router.replace({ path: "/logistics" });
      }
    }
  }
};
</script>

<style lang="less">
#preloadedImages {
  width: 0px;
  height: 0px;
  display: inline;
  background-image: url(./assets/img/banner1.jpg), url(./assets/img/banner2.jpg),
    url(./assets/img/banner3.jpg), url(./assets/img/banner4.jpg);
}
.app-wrap {
  // line-height: 2;
  box-sizing: border-box;
  background-color: #fff;
  // background-size: 100% 100%;
  .font46 {
    font-size: 44px !important;
  }
  .font36 {
    font-size: 36px !important;
  }
  .button-item {
    position: relative;
    overflow: hidden;
    width: 160px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
    border: 1px solid #2e64ee;
    color: #2e64ee;
    font-size: 16px;
    background-color: transparent;
    transition: 0.25s;
    z-index: 1;
    box-sizing: border-box;
    &:hover {
      color: #fff;
      &::before {
        transform: translate(-50%, -50%) rotate(-45deg) scaleX(1);
      }
    }
    &::before {
      position: absolute;
      content: "";
      top: 50%;
      left: 50%;
      z-index: -1;
      width: 200%;
      height: 400%;
      background: #2e64ee;
      transition: 0.25s;
      transform: translate(-50%, -50%) rotate(-45deg) scaleX(0);
    }
  }
  .content-article {
    color: #666;
    font-size: 16px;
    line-height: 2;
    p {
      // text-align: left !important;
      img {
        width: 600px !important;
        display: block !important;
        height: auto !important;
        margin-left: calc((100% - 600px) / 2) !important;
      }
    }

    section img {
      width: auto !important;
      margin: 0 auto !important;
      max-width: 450px;
      display: inherit;
    }
    img[title="qrcode_for_gh_fa4dc93aad46_258.jpg"] {
      width: 100px !important;
    }
    section .wxw-img {
      margin: 0 auto !important;
      height: auto !important;
      max-width: 450px !important;
      display: block;
      max-height: auto !important;
    }
    section p strong,
    section strong {
      // width: 100%;
      //  display: inline-block;
      //  text-align: center !important;
    }
  }
  .wcolor {
    color: #fff;
  }
  .header {
    height: 80px;
    position: relative;
    line-height: 80px;
    .menu-block {
      float: right;
      line-height: 1;
      margin-top: 20px;
      padding-right: 145px;
      .mebu-item {
        display: inline-block;
        cursor: pointer;
        vertical-align: middle;
        margin-right: 50px;
        height: 60px;
        color: #000;
        font-size: 16px;
        cursor: pointer;
        div:nth-child(2) {
          color: #bbb;
          margin-top: 10px;
        }
        img {
          margin-left: 0;
          margin-top: 12px;
        }
      }
    }

    .loginOutLeft {
      padding-right: 20px !important;
    }
    .logo {
      width: 130px;
      margin-left: 20px;
      cursor: pointer;
    }
  }
  .opa-bg {
    background: #fff;
  }
  .basic-footer {
    height: 400px;
    .footer-top {
      overflow: hidden;
      text-align: center;
      height: 320px;
      background: url(./assets/img/footerbg.png);
      .footer-left {
        margin: 80px 0 0 12%;
        text-align: left;
        width: 50%;
        float: left;
        .mt30 {
          margin-top: 30px;
        }
        .item {
          font-size: 16px;
          color: #d7d5d5;
          height: 36px;
          line-height: 36px;
        }
      }
      .footer-right {
        width: 35%;
        margin-top: 90px;
        float: right;
        img {
          width: 170px;
          height: 170px;
          margin-right: 50px;
        }
      }
    }
    .footer-bottom {
      position: relative;
      height: 80px;
      line-height: 80px;
      background: #000;
      color: #b6b6b6;
      font-size: 15px;
      .text {
        position: absolute;
        right: 72px;
        top: 0;
      }
      img {
        height: 55px;
        margin-left: 70px;
      }
    }
  }
}

.user-right {
  position: absolute;
  right: 4px;
  top: 8px;
  border-bottom: none !important;
  .el-menu--horizontal > .el-submenu .el-submenu__title {
    color: #333;
    font-size: 16px;
  }
  .el-submenu [class^="el-icon-"] {
    text-align: center;
    font-size: 26px;
  }
  .el-menu.el-menu--horizontal,
  .el-menu--horizontal > .el-submenu.is-active .el-submenu__title,
  .el-submenu.is-active .el-submenu__title {
    border-bottom: none !important;
  }
}
.nav-login {
  position: absolute;
  right: 40px;
  top: 22px;
  width: 80px !important;
  height: 35px;
  line-height: 35px;
  text-align: center;
  border: 1px solid #1774dc;
  color: #1774dc;
  cursor: pointer;
}
.loginout-box {
  width: 180px !important;
  top: 75px !important;
  // left: 1759px!important;
  .loginout-name {
    width: 88px !important;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: inline-block;
  }
  .el-menu--popup {
    min-width: 180px !important;
    text-align: center;
  }
}
.first-bg {
  background-image: url(./assets/img/banner1.jpg);
}
.two-bg {
  background-image: url(./assets/img/banner2.jpg);
}
.three-bg {
  background-image: url(./assets/img/banner3.jpg);
}
.four-bg {
  background-image: url(./assets/img/banner4.jpg);
}

.animatef {
  visibility: hidden;
  -webkit-animation-duration: 0.8s;
  animation-duration: 0.8s;
}
.animatem {
  visibility: hidden;
  -webkit-animation-duration: 1.2s;
  animation-duration: 1.2s;
}
.animatew {
  visibility: hidden;
  -webkit-animation-duration: 1.6s;
  animation-duration: 1.6s;
}
.slideUpIn60 {
  visibility: visible;
  -webkit-animation-name: slideUpIn60;
  animation-name: slideUpIn60;
}
@keyframes slideUpIn60 {
  0% {
    transform: translate3d(0, 80%, 0);
    visibility: hidden;
  }
  100% {
    transform: translateZ(0);
    visibility: visible;
  }
}
.bottomT {
  height: 40px;
  line-height: 62px;
  a {
    color: #b6b6b6;
  }
  a:hover {
    color: #fff;
  }
}
.bottomP {
  font-size: 12px;
  height: 36px;
  line-height: 36px;
  padding-left: 20px;
  .ml40 {
    margin-left: 40px;
  }

  a {
    color: #b6b6b6;
  }
  a:hover {
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue